import { render, staticRenderFns } from "./toDeal.vue?vue&type=template&id=7b5ae8b2&"
import script from "./toDeal.vue?vue&type=script&lang=js&"
export * from "./toDeal.vue?vue&type=script&lang=js&"
import style0 from "./toDeal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports